/*
 * Initial AU – header: mega menu, sliding nav indicator, glass-on-scroll.
 * No dependencies. Respects prefers-reduced-motion via CSS.
 */
(function () {
  'use strict';

  var nav = document.querySelector('[data-iau-nav]');
  var header = document.querySelector('.header-section header.header') || document.querySelector('header.header');
  var desktop = window.matchMedia('(min-width: 992px)');

  /* ---------- Glass header on scroll ---------- */
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('iau-scrolled', window.scrollY > 12);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (!nav) return;

  /* ---------- Page dimmer behind the open menu ---------- */
  var overlay = document.createElement('div');
  overlay.className = 'iau-mm-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  document.body.appendChild(overlay);

  /* ---------- Sliding indicator under top-level links ---------- */
  var indicator = nav.querySelector('[data-iau-indicator]');
  function moveIndicator(item) {
    if (!indicator) return;
    if (!item) {
      indicator.classList.remove('is-visible');
      return;
    }
    var link = item.querySelector('.iau-nav-link span') || item;
    var navBox = nav.getBoundingClientRect();
    var box = link.getBoundingClientRect();
    indicator.style.width = box.width + 'px';
    indicator.style.transform = 'translateX(' + (box.left - navBox.left) + 'px)';
    indicator.classList.add('is-visible');
  }
  function restingItem() {
    return nav.querySelector('.iau-nav-item.is-current');
  }

  /* ---------- Mega panels ---------- */
  function setPanelTop() {
    if (!header) return;
    var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--iau-mm-top', bottom + 'px');
  }
  window.addEventListener('scroll', function () { if (openItem) setPanelTop(); }, { passive: true });

  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-iau-item]'));
  var openItem = null;
  var openTimer = null;
  var closeTimer = null;

  function loadImages(scope) {
    scope.querySelectorAll('img[data-iau-src]').forEach(function (img) {
      if (img.dataset.iauSrcset) img.srcset = img.dataset.iauSrcset;
      img.src = img.dataset.iauSrc;
      img.removeAttribute('data-iau-src');
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  }

  function open(item) {
    clearTimeout(closeTimer);
    if (openItem === item) return;
    var switching = !!openItem;
    if (openItem) close(openItem, true);
    var panel = item.querySelector('[data-iau-panel]');
    if (!panel) return;
    var activePane = panel.querySelector('.iau-mm-pane.is-active') || panel.querySelector('.iau-mm-pane');
    // Panels without product previews (e.g. the brand cards) load their pictures straight away.
    loadImages(activePane || panel);
    setPanelTop();
    item.classList.add('is-open');
    item.classList.toggle('is-switch', switching);
    panel.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('inert');
    var trigger = item.querySelector('[data-iau-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('iau-mm-open');
    openItem = item;
    // Warm up the other categories' images once the panel is showing.
    setTimeout(function () { if (openItem === item) loadImages(panel); }, 600);
  }

  function close(item, instant) {
    if (!item) return;
    var panel = item.querySelector('[data-iau-panel]');
    item.classList.remove('is-open', 'is-switch');
    delete item.dataset.iauTapped;
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
    }
    var trigger = item.querySelector('[data-iau-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
    if (!instant && !openItem) document.documentElement.classList.remove('iau-mm-open');
  }

  function closeAll() {
    clearTimeout(openTimer);
    if (openItem) close(openItem);
    document.documentElement.classList.remove('iau-mm-open');
    moveIndicator(restingItem());
  }

  items.forEach(function (item) {
    var panel = item.querySelector('[data-iau-panel]');
    if (panel) panel.setAttribute('inert', '');

    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch' || !desktop.matches) return;
      clearTimeout(closeTimer);
      moveIndicator(item);
      clearTimeout(openTimer);
      if (panel) {
        // Short hover intent so passing the mouse over the bar doesn't flash panels.
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 90);
      } else if (openItem) {
        closeTimer = setTimeout(closeAll, 120);
      }
    });

    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeAll, 220);
    });

    var trigger = item.querySelector('[data-iau-trigger]');
    if (trigger && panel) {
      // Touch / pen (e.g. iPad): first tap opens the panel, second tap follows the link.
      var lastPointer = 'mouse';
      trigger.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType; });
      trigger.addEventListener('click', function (e) {
        if (!desktop.matches || lastPointer === 'mouse') return;
        if (item.classList.contains('is-open') && item.dataset.iauTapped) return;
        e.preventDefault();
        item.dataset.iauTapped = '1';
        open(item);
        moveIndicator(item);
      });
    }

    // Keyboard: opening on focus, closing when focus leaves.
    item.addEventListener('focusin', function () {
      if (!desktop.matches) return;
      moveIndicator(item);
      if (panel) open(item);
      else if (openItem) close(openItem);
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            close(item);
            if (!openItem) document.documentElement.classList.remove('iau-mm-open');
          }
        }, 0);
      }
    });

    /* Live preview: hovering a category swaps the products on the right. */
    if (panel) {
      var links = panel.querySelectorAll('[data-iau-preview]');
      links.forEach(function (a) {
        var show = function () {
          var pane = panel.querySelector('[data-iau-pane="' + a.dataset.iauPreview + '"]');
          if (!pane) return;
          links.forEach(function (l) { l.classList.toggle('is-active', l === a); });
          if (pane.classList.contains('is-active')) return;
          loadImages(pane);
          panel.querySelectorAll('.iau-mm-pane.is-active').forEach(function (p) { p.classList.remove('is-active'); });
          pane.classList.add('is-active');
        };
        a.addEventListener('pointerenter', show);
        a.addEventListener('focus', show);
      });
    }
  });

  nav.addEventListener('pointerleave', function () {
    setTimeout(function () { if (!openItem) moveIndicator(restingItem()); }, 240);
  });

  overlay.addEventListener('pointerenter', function () { closeTimer = setTimeout(closeAll, 120); });
  overlay.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) {
      var trigger = openItem.querySelector('[data-iau-trigger]');
      closeAll();
      if (trigger) trigger.focus();
    }
  });

  desktop.addEventListener && desktop.addEventListener('change', closeAll);
  window.addEventListener('resize', function () { moveIndicator(openItem || restingItem()); });

  // Place the indicator under the current section once fonts have settled.
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () {
    moveIndicator(restingItem());
  });
})();
